import React from "react"

import { arrayWithContents } from "../../../../utils"
import FilterSampleObsPopover from "./FilterSampleObsPopover"
import OverlayRunsButton from "./OverlayRunsButton"
import ToggleGridlinesButton from "./ToggleGridlinesButton"
import ToggleOutliersButtons from "./ToggleOutliersButtons"
import GraphEditModalButton from "./GraphEditModalButton"

export default function GraphingButtonToolbar({
  graphKey,
  plotEntry,
  intl,
  index,
  crossPlotProps,
  overlayRuns,
  availableRuns,
  toggleAvailable,
  axesAndRanges,
  baseTime,
  timeExtractor,
  allowGraphEdit = true,
  small,
}) {
  const updateGraph = (updatedGraph) => {
    plotEntry.plotConfigUpdater(updatedGraph, index)
  }
  return (
    <>
      <ToggleGridlinesButton op={graphKey} plotEntry={plotEntry} intl={intl} small={small} />
      {(arrayWithContents(graphKey.observations) || arrayWithContents(graphKey.microbes)) && (
        <>
          {!["microbial-community"].includes(graphKey.special) && (
            <FilterSampleObsPopover
              intl={intl}
              graphKey={graphKey}
              index={index}
              updateGraph={updateGraph}
              sample_types={crossPlotProps?.["sample_types"] || []}
              plotConfigUpdater={plotEntry.plotConfigUpdater}
            />
          )}
          {overlayRuns && !["rnaseq"].includes(graphKey.special) && (
            <OverlayRunsButton
              op={graphKey}
              intl={intl}
              graphIndex={index}
              plotEntry={plotEntry}
              availableRuns={availableRuns}
              overlayRuns={overlayRuns}
              small={small}
            />
          )}
          <ToggleOutliersButtons
            toggleAvailable={toggleAvailable}
            plotEntry={plotEntry}
            graphKey={graphKey}
            intl={intl}
            small={small}
          />
          {allowGraphEdit && (
            <GraphEditModalButton
              intl={intl}
              loading={availableRuns.filter((r) => r.loading)}
              op={graphKey}
              updateGraph={updateGraph}
              axesAndRanges={axesAndRanges}
              baseTime={baseTime}
              timeExtractor={timeExtractor}
              small={small}
            />
          )}
        </>
      )}
    </>
  )
}
